<template>
  <div>
    <div class="row pt-2 pb-3">
      <div class="col-lg-4 col-md-5 ">
        <div class=" row d-flex justify-content-center align-items-center">
          <div class="col-12 d-flex justify-content-center align-items-center">
            <h2 class="overall_review m-0" style="font-weight: 500;font-size: 50px;">
              {{ n(data.total) }}
            </h2>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <el-rate
              v-model="data.overallRating"
              :colors="colors"
              disabled
              size="small"
            />
          </div>
          <div class="col-12 d-flex justify-content-center align-items-center mt-2">
            <span class="text-center">
              {{ n(data.total) }} 評分
            </span>
          </div>
        </div>

      </div>
      <div class="col-lg-8 col-md-7 pt-sm-3 pt-md-0" >
        <div v-for="rating in data.rating" class="row d-flex align-items-center mb-2 font-size-sm">
          <div class="col-3 text-nowrap ">
            <span class="d-inline-block align-middle text-body">
              {{ rating.label }}
            </span>
          </div>
          <div class="col-8">
            <el-progress :percentage="rating.count != 0 ? (rating.count / data.total) * 100 : 0" :showText="false" :color="rating.color" />
          </div>
          <div class="col-1 text-body">
            <span class="ml-3 float-right">
              {{ n(rating.count) }}
            </span>
          </div>
        </div>

      </div>
    </div>

    <div class="row pb-4 mb-3">
      <div style="display: block;width:100%;text-align: center;background: #F3F4F5;border-radius: 5px;padding:5px;">
      </div>
    </div>

    <div class="row pb-4">
      <div class="col-12" id="product-review-list">
        <div v-for="review in reviews_of_product" :key="review.id" class="p-2 mb-4">
          <div class="row product-review d-flex ">
            <div class="col-md-4 d-flex mb-3 pr-2">
              <div class="media media-ie-fix w-100">
                <img style="max-height: 64px;"
                  class="rounded-circle" width="64"
                  onerror="this.src='/static/assets/front-end/img/image-place-holder.png'"
                  :src="review.picture"
                  :alt="review.name"
                />

                <div class="media-body pl-3 text-body">
                  <span class="font-size-sm mb-0 text-body" style="font-weight: 700;font-size: 12px;">
                    {{review.name}}
                  </span>
                  <div class="d-flex">
                    <div class="mr-2">
                      <i class="sr-star czi-star-filled active"></i>
                    </div>
                    <div class="text-body" style="font-weight: 400;font-size: 15px;">
                      {{review.rate}}/5
                    </div>
                  </div>
                  <div class="text-body" style="font-weight: 400;font-size: 13px;">
                    {{review.create_at}}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-8">
              <p class="mb-2 text-body" style="word-wrap:break-word;">{{review.comment}}</p>
              <div v-if="review.attachment.length">
                <el-image
                  v-for="(photo, idx) in review.attachment"
                  :key="idx"
                  style="border-radius: 5px;border:1px;border-color: #7a6969; height: 67px ; margin-right: 5px;"
                  :src="photo"
                  :preview-src-list="[photo]"
                  fit="cover"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="card mb-2">
          <div class="card-body">
            <h6 class="text-danger text-center">查無買家秀</h6>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-footer d-flex justify-content-center align-items-center">
          <el-button type="primary" size="large">查看更多</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue'
import { useI18n } from "vue-i18n"
import { breakpoint, notificationErrors } from "../../utils"
import dayjs from "dayjs"

const props = defineProps({
  modelValue: Object
})
const emit = defineEmits(['update:modelValue'])

const { t, n, locale } = useI18n()

const isMobile = computed(() => breakpoint.value.xs)
const colors = ref(['#99A9BF', '#F7BA2A', '#FF9900']) // same as { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
const data = computed(() => {
  const labels = ["非常棒", "很好", "普通", "有點差", "非常糟"]
  const colors = ["#3b71de", "#a7e453", "#ffda75", "#fea569", "#f56c6c"]
  const rating = []
  let total = 0
  let overallRating = 0
  let i = 0
  do {
    const count = Math.floor(Math.random()*100 + 10)
    const rate = Math.floor(Math.random()*5 + 1)
    // console.log(i, count, rate)

    total += count
    overallRating += rate
    rating.push({
      label: labels[i],
      color: colors[i],
      count,
      rate,
    })
    i += 1;
  } while (i < 5);

  overallRating = Math.floor(overallRating / 5)

  return {
    total,
    overallRating,
    rating,
  }
})
const reviews_of_product = computed(() => {
  const reviews = []
  const srcList = [
    'https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg',
    'https://fuss10.elemecdn.com/1/34/19aa98b1fcb2781c4fba33d850549jpeg.jpeg',
    'https://fuss10.elemecdn.com/0/6f/e35ff375812e6b0020b6b4e8f9583jpeg.jpeg',
    'https://fuss10.elemecdn.com/9/bb/e27858e973f5d7d3904835f46abbdjpeg.jpeg',
    'https://fuss10.elemecdn.com/d/e6/c4d93a3805b3ce3f323f7974e6f78jpeg.jpeg',
    'https://fuss10.elemecdn.com/3/28/bbf893f792f03a54408b3b7a7ebf0jpeg.jpeg',
    'https://fuss10.elemecdn.com/2/11/6535bcfb26e4c79b48ddde44f4b6fjpeg.jpeg',
  ]
  let i = 0
  do {
    i += 1
    const rate = Math.floor(Math.random()*5 + 1)
    const createAt = dayjs().subtract(1+i, 'day')

    reviews.push({
      id: i,
      name: `Fake Name ${i}`,
      picture: "https://6valley.6amtech.com/storage/app/public/profile/2022-04-20-625fa7d513aa5.png",
      comment: "test.........",
      create_at: createAt.fromNow(),
      rate,
      attachment: srcList,
    })
    
  } while (i < 3)

  return reviews
})

</script>
